export default import.meta.ROLLUP_FILE_URL_gI2pe7U$I77F5dvguXPliQ